module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_mobile_e3bb495710726fc037eb4ad116d84e09.webp";